module.exports = __webpack_public_path__ + "static/media/no-task.381dfb05.png";